<template>
  <v-row justify="center">
    <v-dialog v-model="dialogRegis" max-width="500" persistent>
        <div class="printed">
            <v-card outlined style="overflow-y: auto;">
                <div class="d-flex flex-row-reverse">
                    <v-btn icon @click="setDialogRegis(false)">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
                <v-card-title class="pt-0">Registrasi Customer</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-0">
                  <v-form @submit="validate" ref="form" v-model="valid" lazy-validation>
                      <v-text-field v-model="inputDataCustomer.name" :rules="[ v => !!v || 'Required.']" label="Name"></v-text-field>
                      <v-text-field v-model="inputDataCustomer.username" :rules="[ v => !!v || 'Required.']" label="Username"></v-text-field>
                      <v-autocomplete
                        v-model="inputDataCustomer.role_id"
                        :items="roles"
                        :rules="[ v => !!v || 'Required.']"
                        item-text='name'
                        item-value='id'
                        label="Tipe User"
                      ></v-autocomplete>
                      <v-text-field 
                        v-model="inputDataCustomer.email"
                        :rules="[ v => !!v || 'Required.']"
                        label="Email">
                      </v-text-field>
                      <v-text-field type="number" v-model="inputDataCustomer.telp" label="Telp"></v-text-field>
                      <v-text-field type="password" v-model="inputDataCustomer.password" label="Password" :rules="[ v => !!v || 'Required.']"></v-text-field>
                      <v-text-field type="password" v-model="inputDataCustomer.password_conf" label="Confirmation" :rules="[ v => !!v || 'Required.']"></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn 
                      class="teal darken-4 white--text"
                      :disabled="!valid"
                      medium
                      @click="validate"
                  >
                      Daftar
                  </v-btn>
              </v-card-actions>
            </v-card>
        </div>
    </v-dialog>
    <v-snackbar style="z-index: 9999"
        :top='true'
        v-model='snackbar.visible'
        :color='snackbar.color'
        :timeout='snackbar.timeout'
        :multi-line='snackbar.multiline'
    >{{snackbar.text}}</v-snackbar>
<!-- 
    <v-overlay :value="overlay" style="z-index: 9999">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->
  </v-row>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, isEmpty, remove, find } from "lodash";
import { QRCanvas } from 'qrcanvas-vue';
import moment from 'moment';
export default {
  name: "DialogRegis",
  components: {
      QRCanvas,
  },
  data() {
    return {
      valid: true,
      inputDataCustomer: {},
      overlay: false,
      roles: []
    };
  },
  computed: {
      ...mapGetters({
          getRoles: "user/getRoles"
      }),
      ...mapState({
          dialogRegis: state => state.pesanan.dialogRegis,
          snackbar: state => state.snackbar,
      })
  },
  mounted() {
    this.initialize()
  },

  methods: {
    ...mapMutations({
      showSnackbar: "showSnackbar",
      // showLoading: "showLoading",
      closeLoading: "closeLoading",
      setDialogRegis: "pesanan/SET_DIALOG_REGIS",
      setCustomer: "pesanan/SET_CUSTOMER",
    }),
    ...mapActions({
      createUser: "user/createUser",
    }),
    async initialize(){
      const getRoles = await this.getRoles
      for(let role of getRoles.data.attributes){
          this.roles.push({
              name: role.name == 'unverified' ? 'Personal' : 'Company',
              id: role.id
          })
      }
    },
    async validate() {
      if (this.$refs.form.validate()) {
        if(this.inputDataCustomer.password==this.inputDataCustomer.password_conf){
          try {
              this.overlay = true
              let response = await this.createUser(this.inputDataCustomer)
              // console.log('response', response)
              if (!response.data.success) {
                  this.showSnackbar({ text: response.data.message, color: 'red', timeout: 1500 })
              } else {
                  this.showSnackbar({ text: 'Registrasi berhasil...', color: 'green', timeout: 1500 })
                  this.setCustomer(response.data.attributes.user)
                  window.localStorage.setItem('dataCustomer', JSON.stringify(response.data.attributes.user));
                  this.inputDataCustomer = {}
                  this.$refs.form.reset()
                  this.$refs.form.resetValidation()
                  this.setDialogRegis(false)
                  // window.localStorage.setItem('listPesanan', JSON.stringify([]));
                  // window.localStorage.setItem('validatorOrder', true);
                  // window.localStorage.setItem('numberOfList', this.numberOfList);
                  // if(window.localStorage.getItem('user_role') == 'stockiest'){
                  //   this.$router.push("/orders");
                  // }else{
                    // this.$router.push("/dashboard");
                  // }
              }
              this.overlay = false
          } catch (err) {
            console.log(err);
          }
        }else{
          this.showSnackbar({ text: 'Password Confirmation tidak cocok', color: 'red', timeout: 1500 })
        }
      }
    },
  }
};
</script>
<style>
@media print {
  body * {
    background: white!important;
  }
}
</style>